<script>
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    token: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],
  data() {
    return {
      copied: false,
    };
  },
  computed: {
    rawToken() {
      return this.token?.raw_token || '';
    },
  },
  methods: {
    async copyToken() {
      try {
        await navigator.clipboard.writeText(this.rawToken);
        this.copied = true;
        useAlert(this.$t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.COPIED'));
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      } catch (error) {
        useAlert(this.$t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.COPY_FAILED'));
      }
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <woot-modal show :on-close="close">
    <div class="p-6 max-w-lg">
      <div class="flex items-center gap-3 mb-4">
        <div
          class="flex items-center justify-center w-10 h-10 rounded-full bg-g-100 dark:bg-g-800"
        >
          <fluent-icon icon="checkmark" size="20" class="text-g-500" />
        </div>
        <h2 class="text-lg font-semibold text-n-slate-12">
          {{ $t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.TITLE') }}
        </h2>
      </div>

      <div
        class="p-4 mb-4 bg-y-50 dark:bg-y-900 border border-y-200 dark:border-y-700 rounded-lg"
      >
        <div class="flex items-start gap-2">
          <fluent-icon
            icon="warning"
            size="20"
            class="text-y-500 flex-shrink-0 mt-0.5"
          />
          <p class="text-sm text-y-800 dark:text-y-200">
            {{ $t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.WARNING') }}
          </p>
        </div>
      </div>

      <div class="space-y-2">
        <label class="block text-sm font-medium text-n-slate-12">
          {{ $t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.TOKEN_LABEL') }}
        </label>
        <div class="flex gap-2">
          <input
            :value="rawToken"
            type="text"
            readonly
            class="flex-1 px-3 py-2 font-mono text-sm border border-n-weak rounded-lg bg-n-alpha-1 text-n-slate-12"
          />
          <NextButton
            :icon="copied ? 'i-lucide-check' : 'i-lucide-copy'"
            :label="
              copied
                ? $t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.COPIED_BTN')
                : $t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.COPY_BTN')
            "
            :blue="!copied"
            :green="copied"
            @click="copyToken"
          />
        </div>
      </div>

      <div class="flex justify-end mt-6">
        <NextButton
          slate
          faded
          :label="$t('KAPTION_ACCESS_TOKENS.TOKEN_MODAL.DONE')"
          @click="close"
        />
      </div>
    </div>
  </woot-modal>
</template>
